import React from "react";

import FormControl, { FormControlProps } from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import { FieldRenderProps } from "react-final-form";

import { useQuery } from "@apollo/client";

import groups from "./groups";

interface Props extends FieldRenderProps<any, any> {
  label?: string;
  formControlProps?: FormControlProps;
}

function GroupSelectField(props: Props) {
  const {
    input: { name, value, onChange, ...restInput },
    meta,
    label,
    formControlProps,
    // ...rest
  } = props;
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) &&
    meta.touched;

  const { data, error, loading } = useQuery(groups, {});
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error);
    return <p>Error :(</p>;
  }

  return (
    <FormControl {...formControlProps} error={showError}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Select
        name={name}
        onChange={onChange}
        inputProps={restInput}
        value={value}
      >
        {data.groups &&
          data.groups.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {item.groupName}
            </MenuItem>
          ))}
      </Select>
      {showError && (
        <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
      )}
    </FormControl>
  );
}

export default GroupSelectField;
